export const mainStyles = {

    checkBoxStyle: {
        color: '#fff',
        '& .MuiSvgIcon-root':
            { fontSize: 24 }
    },
    cardStyles:
    {
        width: { xs: 360, sm: 500 },
        bgcolor: '#003755',
        '& span': {
            color: '#fff'
        },
        '& h4': {
            color: '#fff'
        },
        '& p': {
            color: '#fff'
        },
        '& svg': {
            color: '#fff'
        },
        '& .css-y5np4p-MuiStack-root': {
            color: '#fff',
        },
    },
    ccCardStyles:
    {
        width: { xs: 360, sm: 1000 },
        mb: 10,
        bgcolor: '#003755',
        '& span': {
            color: '#fff'
        },
        '& h4': {
            color: '#fff'
        },
        '& p': {
            color: '#fff'
        },
        '& svg': {
            color: '#fff'
        },
        '& .css-y5np4p-MuiStack-root': {
            color: '#fff',
        },
        '& .MuiTypography-body1': {
            color: '#fff'
        },
        '& .MuiTypography-body2': {
            color: '#fff'
        }
    },
    newCardStyles:
    {
        width: '100%',
        p: 0,
        ml: 0,
        mr: 0,
        bgcolor: '#DAE5F1',
        // '& span': {
        //     color: '#000'
        // },
        // '& h4': {
        //     color: '#000'
        // },
        // '& p': {
        //     color: '#000'
        // },
        // '& svg': {
        //     color: '#000'
        // },
        // '& .css-y5np4p-MuiStack-root': {
        //     color: '#000',
        // },
        // '& .MuiOutlinedInput-root': {
        //     borderColor: '#000'
        // },
        // '& .MuiOutlinedInput-notchedOutline': {
        //     borderColor: '#000'
        // },
        // "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        //     borderColor: "#000"
        // },
        // '& .MuiSelect-iconOutlined': {
        //     color: '#000',
        //     borderColor: "#000"
        // },
        // '& .MuiFormControl-root': {
        //     borderWidth: 0,
        //     borderColor: "#000"
        // },
        // '& .Mui-disabled': {
        //     color: '#000',
        //     borderColor: '#000',
        // }
    }

}

